class CardFront {
    constructor({
        cardId = null,
        code = null,
        remoteId = null,
        employeeId = null,
        name = null,
        cardType = null,
        validFrom = null,
        validUntil = null,
        isActive = null,
        vendorId = null,
        employee = {
            id: null,
            firstName: null,
            lastName: null,
            hiddenId: null,
            hiddenFirstName: null,
            hiddenLastName: null,
        },
        isnew = false,
    }) {
        this.cardId = cardId;
        this.code = code;
        this.remoteId = remoteId;
        this.employeeId = employeeId;
        this.name = name;
        this.cardType = cardType;
        this.validFrom = validFrom;
        this.validUntil = validUntil;
        this.isActive = isActive;
        this.vendorId = vendorId;
        this.employee = employee;
        this.isnew = isnew;
    }

    updateEmployee(employeeId, firstName, lastName) {
        this.employee = {
            id: employeeId,
            firstName: firstName,
            lastName: lastName,
            hiddenId: null,
            hiddenFirstName: null,
            hiddenLastName: null
        }
    }
}

class CardBack {
    constructor({
        cardId = cardId,
        code = code,
        remoteId = remoteId,
        employeeId = employeeId,
        name = name,
        cardType = cardType,
        validFrom = validFrom,
        validUntil = validUntil,
        isActive = isActive,
        vendorId = vendorId,
        employee = {
            id: null,
            hiddenId: null
        },
        isnew = isnew,

    }) {
        this.cardId = cardId;
        this.code = code;
        this.remoteId = remoteId;
        this.employeeId = employee.id ? employee.id : employee.hiddenId;
        this.name = name;
        this.cardType = cardType;
        this.validFrom = validFrom;
        this.validUntil = validUntil;
        this.isActive = isActive ? true : false;
        this.vendorId = vendorId;
    }
}

export { CardFront, CardBack };